<template>
  <div class="solution">
    <div class="solution-banner">
      <img class="solution-banner-img" :src="fileUrl+banner.img" alt="">
      <div class="solution-banner-title">
        <div>{{banner.title}}</div> 
        <div>{{banner.description}}</div>
      </div>
    </div>
    <div class="solution-title">
      <div>case</div>
      <div>客户案例</div> 
    </div>
    <div class="solution-content" v-for="(item,index) in list" :key="index">        
      <div class="solution-content-title">
        <div>
          <div ><div>{{item.title}}</div> </div>
        </div>          
      </div> 
      <div class="solution-content-item" :class="index%4 == 0 ? 'first':(index%4 == 1 ?'second':(index%4 == 2 ?'third':'forth'))">  
         <div v-if="index%4 == 0 || index%3 == 0 " class="imgLeft">
           <img :src="fileUrl+item.thumb" alt="">
           <div>{{item.description || '暂无数据'}}</div>
         </div>
          <div v-else class="imgRight">
            <div>{{item.description || '暂无数据'}}</div>
            <img :src="fileUrl+item.thumb" alt="">
          </div>


        <!-- <div class="solution-content-item-right">
          <div>{{item.content || '暂无数据'}}</div> 
        </div> -->
        
      </div>
    </div>
    
  </div>
</template>

<script>
import { mapState} from 'vuex'
import * as API from '../api/api'
export default {
  data(){
    return{
      defaultTitle:'整体解决方案',
      defaultDes:'专注专业 精益求精',
      defaultImg:require('../assets/img/solution_top.png'),
      list:[],
      banner:{},
    }
  },
  computed: {
    ...mapState({fileUrl:state => state.fileUrl})
  },
  mounted(){
    this.getBanner()
    this.getComponent()
  },
  methods:{
    getBanner(){
      let that=this
      API.getBanner(1).then(res=>{
        if (res&&res.data) {
          that.banner={
            title:res.data.title,
            description:res.data.description,
            img:res.data.imgs.length>0 ? res.data.imgs[0] : that.defaultImg
          }
        }else{
          that.banner={
            title:that.defaultTitle,
            description:that.defaultDes,
            img:that.defaultImg
          }
        }
      })
    },
    getComponent(){
      let that=this
      let params={
        ComponentType:1,
        page:1,
        take:20
      }
      API.getComponents(params).then(res=>{
        // console.log(res.data.contents);
        if (res&&res.data) {
          that.list=res.data.contents
        } else {
          that.$message({
            message: '获取数据失败',
            type: 'warning',
            duration:4000
          })
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
  .solution{
    &-banner{
      width: 100%;
      height: 4.4rem;
      position: relative;
      &-img{
        width: 100%;
        height: 100%;
      }
      &-title{
        position: absolute;
        top: 2rem;
        left: 4rem;
        color: #fff;
        font-size: 0.38rem;
        >div:nth-child(2){
          font-size: 0.24rem;
          color: #FDF7F7;
          margin-top: 0.3rem;
        }
      }
    }
    &-title{
      margin: auto;
      text-align: center;
      margin-top: 0.3rem;        
      position: relative;
      >div:nth-child(1){
        position: relative;
        color: #E4EBFE;
        font-size: 1.2rem;
      }
      >div:nth-child(2){
        position: absolute;
        top: 0.9rem;
        left: 0;
        right: 0;
        color: #202020;
        font-size: 0.38rem;
        font-weight: 350;
        letter-spacing: 6px;
      }
    }
    &-content{
      margin:auto;
      &-title{
        width: 12rem;
        margin: auto;
        padding-top:0.8rem;
        >div{
          align-items: center;
          display: flex;
          margin-bottom: 0.28rem;
          >div{
            margin-left:10px;
            font-size:0.38rem;
            color: #202020;
            background: #E4EBFE;
            height: 0.2rem;
            padding: 0 0.2rem;
            >div{
              margin-top: -0.2rem;
              letter-spacing: 4px;
            }
          }
        }
        >img{
          width: 7.8rem;
          // height: 3.62rem;
        } 
      }
      &-item{
        width: 12rem;
        height: 4.2rem;
        margin:0.5rem auto; 
        background-repeat: no-repeat !important;
        background-size: 100% 100% !important;       
      }
      .first{        
        background: url('../assets/img/solution_first.png');
        margin-bottom: 1rem;
      } 
      .second{
        background: url('../assets/img/solution_second.png');        
      } 
      .third{
        background: url('../assets/img/solution_third.png');   
        margin-bottom: 1.2rem; 
      } 
      .forth{
        background: url('../assets/img/solution_forth.png');   
        margin-bottom: 1rem; 
      } 
      .imgLeft{
        padding-top: 0.85rem;
        padding-left: 0.6rem;
        display: flex;
        >img{
          width: 5.7rem;
          height: 4rem;
        }
        >div{
          width: 4.8rem;
          margin-left: 0.5rem;
          color: #fff;
          font-size: 0.28rem;
        }
      }
      .imgRight{
        display: flex;
        align-items: flex-start;
        padding-top: 0.8rem;
        >img{
          width: 5.7rem;
          height: 4rem;
        }
        >div{
          width: 4.8rem;
          margin-left: 0.5rem;
          margin-right: 0.5rem;
          color: #fff;
          font-size: 0.28rem;
        }
      }
    }
    &-content:nth-child(2n){
      background: #F4F6FC;
      padding-bottom: 0.7rem;
    }
  }
</style>